import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js/min";

/** Canonicalize at the API boundary; never rewrite the user's partially typed input. */
export function normalizeMobilePhone(value: string, countryCode: string): string {
  const digits = value.trim().replace(/[٠-٩]/g, d => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)))
    .replace(/[۰-۹]/g, d => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d))).replace(/[\s()-]/g, "");
  if (!/^\+?[0-9]+$/.test(digits)) throw new Error("PHONE_FORMAT");
  const international = digits.startsWith("00") ? "+" + digits.slice(2)
    : countryCode === "JO" && /^9627[0-9]{8}$/.test(digits) ? "+" + digits : digits;
  const phone = parsePhoneNumberFromString(international, { defaultCountry: countryCode as CountryCode, extract: false });
  if (!phone?.isValid() || phone.country === "JO" && phone.nationalNumber.startsWith("70")) throw new Error("PHONE_FORMAT");
  return phone.number;
}

/** Synthetic input is compiled out of Production, just like the sign-in bypass. */
export function normalizeAdminPhone(value: string, countryCode: string): string {
  const digits = value.trim().replace(/[٠-٩]/g, d => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)))
    .replace(/[۰-۹]/g, d => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d))).replace(/[\s()-]/g, "");
  if (__MZN_SIMULATION_TOOLS__ && countryCode === "JO") {
    const local = digits.replace(/^(?:\+962|00962|962)/, "0");
    const national = local.startsWith("7") ? "0" + local : local;
    if (/^0700000[0-9]{3}$/.test(national)) return national;
  }
  return normalizeMobilePhone(value, countryCode);
}
